import type { ComponentPropsWithoutRef, HTMLAttributes } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { ScreenSizeRadioGroup } from "@circle-react-shared/ScreenSizeRadioGroup";

interface CanvasSizeToggleProps extends HTMLAttributes<HTMLDivElement> {
  options?: ComponentPropsWithoutRef<typeof ScreenSizeRadioGroup>["options"];
}

export const CanvasSizeToggle = ({
  className,
  options,
  ...props
}: CanvasSizeToggleProps) => {
  const { canvasSize, setCanvasSize } = useBuilderStore(state => ({
    canvasSize: state.canvasSize,
    setCanvasSize: state.setCanvasSize,
  }));

  return (
    <div
      className={classNames("bg-primary rounded-xl p-1", className)}
      data-testid="canvas-size-toggle"
      {...props}
    >
      <ScreenSizeRadioGroup
        selected={canvasSize}
        onChange={setCanvasSize}
        options={options}
      />
    </div>
  );
};
